import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROLE_NAV } from '../../config/constants';
import Sidebar from './Sidebar';

// Путь → раздел ROLE_NAV — держим в паре с NAV_ITEMS в Sidebar.jsx. До
// появления первой по-настоящему урезанной роли (marketing, 29.07.2026)
// проверки маршрута на клиенте не было вообще — только пункты меню
// скрывались, прямой переход по адресу открывал страницу (сервер данные
// не отдавал по роли, но пустая/сломанная страница — плохой UX).
const PATH_TO_SECTION = {
  '/dashboard':    'dashboard',
  '/crm':          'crm',
  '/advertising':  'advertising',
  '/bookings':     'bookings',
  '/transactions': 'transactions',
  '/bank-import':  'bank_import',
  '/reports':      'reports',
  '/payroll':      'payroll',
  '/breakfasts':   'breakfasts',
  '/settings':     'settings',
  '/users':        'users',
  '/audit':        'audit_log',
};

export default function Layout() {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace />;

  const section = PATH_TO_SECTION[location.pathname];
  const allowed = ROLE_NAV[user.role] || [];
  // allowed.includes('dashboard') — защита от зацикливания редиректа, если
  // роль вообще не имеет доступа к дашборду (сейчас такой роли нет, но лучше
  // не полагаться на это молча).
  if (section && !allowed.includes(section) && allowed.includes('dashboard')) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg-base)' }}>
      <Sidebar />
      <main style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>
    </div>
  );
}
